import React, { useMemo } from "react";
import CommonTable from "../../Common/CommonTable";
import { getDiagnosticCollection } from "../../../redux/reducers/DiagnosticReducer";
import { useTypedSelector } from "../../../redux/reducers/RootReducer";
import { DiagnosticInfo } from "../../../Model/Diagnostic";

type DiagnosticInfoAllString = {
  name: string;
  information: string;
  positionError: string;
  positionErrorNative: string;
  tolerance: string;
  id: string;
};

const DiagnosticTable = () => {
  const pageLineSize = 11;
  const diagnosticCollection = useTypedSelector((state) =>
    getDiagnosticCollection(state)
  );

  let infos: DiagnosticInfoAllString[] = [];

  for (let i = 0; i < diagnosticCollection.allIds.length; i++) {
    const id = diagnosticCollection.allIds[i];
    const diagnostic = diagnosticCollection.byId[id];
    infos = infos.concat(
      diagnostic.infos.map((info) => {
        return {
          name: info.name,
          information: info.information,
          positionError: info.positionError.toString(),
          positionErrorNative: info.positionErrorNative.toString(),
          tolerance: info.tolerance.toString(),
          id: info.id,
        };
      })
    );
  }

  for (let index = infos.length; index < pageLineSize; index++) {
    infos.push({
      name: "",
      information: "",
      positionError: "",
      positionErrorNative: "",
      tolerance: "",
      id: "",
    });
  }

  const getTableColumnConfig = useMemo(
    () => [
      {
        id: "name",
        Header: "Motor Name",
        accessor: (p: any) => {
          return p.name;
        },
        width: "34%"
      },
      {
        id: "id",
        Header: "Motor",
        accessor: (p: any) => {
          return p.id;
        },
        width: "22%"
      },
      {
        id: "positionError",
        Header: "Offset E",
        accessor: (p: any) => {
          return p.positionError;
        },
        width: "22%",
        align: "center",
      },
      {
        id: "positionErrorNative",
        Header: "Offset Native",
        accessor: (p: any) => {
          return p.positionErrorNative;
        },
        width: "22%",
        align: "center",
      },
    ],
    []
  );

  return (
    <div>
      <CommonTable
        data={infos}
        columns={getTableColumnConfig}
        enablePagination={true}
        enableSelection={false}
        enableFilter={false}
        enableManualSorting={false}
        pageLineSize={pageLineSize}
        sortingRules={[]}
        variant={"no-separator"}
      />
    </div>
  );
};

export default DiagnosticTable;
